import { ComponentProps, FC, useMemo } from 'react';

import classNames from 'classnames';

import { TestMetadata } from '../../types';
import { useResponsiveNavBar } from '../NavBarContext';

import './NavBarItem.scss';

export interface NavBarItemProps extends ComponentProps<'div'> {
  /** Custom class to pass to nav bar item */
  className?: string;
  /** TestMetadata to use for nar bar item */
  testMetadata?: TestMetadata;
  /** Set visibility on narbaritem */
  visibility?: 'all' | 'desktop' | 'mobile';
}

const NavBarItem: FC<NavBarItemProps> = ({
  className,
  testMetadata,
  children,
  visibility = 'all',
  ...otherProps
}) => {
  const { getBreakpointClassName } = useResponsiveNavBar();

  const navBarItemClassNames = useMemo(
    () =>
      classNames(
        getBreakpointClassName('sb-navbar-item'),
        {
          [`sb-navbar-item__visibility-${visibility}`]: visibility !== 'all',
        },
        className,
      ),
    [className, getBreakpointClassName, visibility],
  );

  return (
    <div className={navBarItemClassNames} {...testMetadata} {...otherProps}>
      {children}
    </div>
  );
};

export default NavBarItem;
